export default "__VITE_ASSET__f964db6c__"